import React from "react";
import Ticket from "./Ticket";

const LaserPrint = React.forwardRef(
    ({ data, isPassengerPartMiddle, printedTime }, ref) => {
        return (
            <Ticket
                data={data}
                isPassengerPartMiddle={isPassengerPartMiddle}
                showForPrint={true}
                ref={ref}
                printedTime={printedTime}
            />
        );
    }
);

export default LaserPrint;
